export const MODAL_SEARCH_PARAM_PREFIX = 'modal-'

export enum URLSearchParamKeys {
  Q = "q",
  MODAL = "modal",
  PLAYLIST = "playlist",
  TRACK = "track",
  PLAY_MODE = "play-mode",
  SCROLL_TO_TRACK = "scroll-to-track",
  AUDIO_CURRENT_TIME = "t",
  COPY_TRACK = MODAL_SEARCH_PARAM_PREFIX + "copy-track",
  MOVE_PLAYLIST = MODAL_SEARCH_PARAM_PREFIX + "move-playlist",
  MOVE_TRACK = MODAL_SEARCH_PARAM_PREFIX + "move-track",
  KEYBOARD_SHORTCUT_INFO_MODAL = MODAL_SEARCH_PARAM_PREFIX + "keyboard-shortcuts",
  SHARE_TRACK_WITH_WORKSPACE = MODAL_SEARCH_PARAM_PREFIX + "share-track-with-workspace",
  TRACK_VIEW_MODAL = MODAL_SEARCH_PARAM_PREFIX + "track",
  TRACK_INFO_MODAL = MODAL_SEARCH_PARAM_PREFIX + "track-info",
  POINT_PREVIEW_MODAL = MODAL_SEARCH_PARAM_PREFIX + "comment-view",
  EDIT_POINT_MODAL = MODAL_SEARCH_PARAM_PREFIX + "comment",
  CREATE_POINT_MODAL = MODAL_SEARCH_PARAM_PREFIX + "create-comment",
  EDIT_SEGMENT_MODAL = MODAL_SEARCH_PARAM_PREFIX + "selection",
  CREATE_SEGMENT_MODAL = MODAL_SEARCH_PARAM_PREFIX + "create-selection",
  EXPORT_SEGMENTS_MODAL = MODAL_SEARCH_PARAM_PREFIX + "export-selections",
  RENAME_TRACK_MODAL = MODAL_SEARCH_PARAM_PREFIX + "rename-track",
  CREATE_PLAYLIST_MODAL = MODAL_SEARCH_PARAM_PREFIX + "create-playlist",
  RENAME_PLAYLIST_MODAL = MODAL_SEARCH_PARAM_PREFIX + "rename-playlist",
  SHARE_TRACK_MODAL = MODAL_SEARCH_PARAM_PREFIX + "share-track",
  SHARE_SEGMENT_MODAL = MODAL_SEARCH_PARAM_PREFIX + "share-selection",
  TAG_MODAL = MODAL_SEARCH_PARAM_PREFIX + "-tag",
  POINT_TAG_MODAL = MODAL_SEARCH_PARAM_PREFIX + "comment-tag",
  SEGMENT_TAG_MODAL = MODAL_SEARCH_PARAM_PREFIX + "selection-tag",
  UPLOAD_MODAL = MODAL_SEARCH_PARAM_PREFIX + "upload",
  USER_PROFILE = MODAL_SEARCH_PARAM_PREFIX + "user-profile",
  EDIT_BAND_WORKSPACE = MODAL_SEARCH_PARAM_PREFIX + "edit-band-workspace",
  CREATE_BAND_WORKSPACE = MODAL_SEARCH_PARAM_PREFIX + "create-band-workspace",
  TAG_ID = "tag-id",
  SEGMENT_ID = "segment-id",
  POINT_ID = "point-id",
}
